import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ConnectedRouter } from '@jauntin/react-ui';
import {
  purchaseButton,
  toggleSummary,
  summaryHeight,
  toggleSummaryMobile,
  startLoading,
  SUMMARY_TOGGLE,
} from '../Actions/actions';
import { formName } from '../Constants/constants';
import RouteParser from '../Helpers/RouteParser';
import Summary from '../Components/Summary/Summary';
import { emptyEventType } from '../Constants/eventTypes';
import { dateHelpers } from '@jauntin/utilities';
import { getTotalEventAttendees } from '../Helpers/StoreSelectors';
const { pickedDaysToNumberedArray } = dateHelpers;

const formValues = formValueSelector(formName);

const purchaseShouldBeEnabled = (state) => {
  const consentCheck = formValues(state, 'consentCheck');
  const excludedCheck = formValues(state, 'excludedCheck');
  const { formPage } = state;
  return (
    (consentCheck &&
      excludedCheck &&
      formPage.eventType &&
      formPage.eventSelectSecondary.valid &&
      formPage.formPartOne &&
      formPage.formPartOne.complete &&
      formPage.formPartTwo &&
      formPage.formPartTwo.complete) ||
    false
  );
};

const mapStateToProps = (state) => ({
  checkoutEnabled: state.formPage.formPartOne.complete,
  checkoutShow: RouteParser.create(
    state.router.location.pathname,
  ).isApplicationPage(),
  consentEnabled: state.formPage.formPartTwo.complete,
  purchaseEnabled: purchaseShouldBeEnabled(state),
  purchaseShow: RouteParser.create(
    state.router.location.pathname,
  ).isCheckoutPage(),
  eventType: state.formPage.eventType.selection || emptyEventType,
  coverage: state.formPage.basicCoverage.coverage.toString(),
  basicCoverageConfirmed: state.formPage.basicCoverage.confirmed,
  eventDates: formValues(state, 'eventDates'),
  eventFrequency: formValues(state, 'eventFrequencyField'),
  daysOfWeek: pickedDaysToNumberedArray(formValues(state, 'daysOfWeekField')),
  eventTotalGuests: getTotalEventAttendees(state),
  eventDailyGuests: formValues(state, 'eventDailyGuests'),
  aboutEventConfirmed: state.formPage.aboutEvent.confirmed,
  eventPerformersCount: formValues(state, 'eventPerformersCount'),
  eventGoods: formValues(state, 'eventGoods'),
  eventFood: formValues(state, 'eventFood'),
  eventExhibition: formValues(state, 'eventExhibition'),
  sellingLiquor: formValues(state, 'ACSellingLiquor'),
  terrorism: formValues(state, 'ACTerrorism'),
  damageToRentedProperty: formValues(state, 'ACDamageToRentedProperty'),
  additionalCoveragesConfirmed: state.formPage.additionalCoverages.confirmed,
  summaryIsOpen: state.formPage.summary.isOpen,
  basicCoverageAmount: state.formPage.priceValues.basicCoverageAmount,
  additionalCoverages: state.formPage.priceValues.additionalCoverages,
  damageToRentedPropertyPrice:
    state.formPage.priceValues.damageToRentedProperty,
  liquor: state.formPage.priceValues.liquor,
  subtotal: state.formPage.priceValues.subtotal,
  isFederalEntity: state.formPage.venue.isFederalEntity,
  isKentuckyEntity: state.formPage.venue.isKentuckyEntity,
  federalSurcharge: state.formPage.priceValues.federalSurcharge,
  stateSurcharge: state.formPage.priceValues.stateSurcharge,
  tax: state.formPage.priceValues.tax,
  total: state.formPage.priceValues.total,
  currentLocation: state.router.location.pathname,
  summHeight: state.formPage.summary.height,
  mobileShow: state.formPage.summary.mobileShow,
  mobileDisplay: state.formPage.summary.mobileDisplay,
  errorResponse: state.formPage.summary.errorResponse,
  isLoading: state.formPage.summary.isLoading,
  venueState: state.formPage.venue.selectedPlaceAddressComponents.state || '',
  address: state.formPage.venue.selectedPlaceAddressComponents,
  usStates: state.formPage.usStates,
  validVenueAddress: state.formPage.venue.validVenueAddressAndState,
  certHolders: state.formPage.summary.additionalCertHolders,
  hasVenueCodeReferral: !!state.formPage.referral.venueCode,
  isGettingCertHolders: state.formPage.summary.isGettingCertHolders,
});

const handlePurchaseClick = (dispatch) => {
  dispatch(startLoading(SUMMARY_TOGGLE));
  dispatch(purchaseButton());
};

const mapDispatchToProps = (dispatch) => ({
  checkoutAction: (location) =>
    dispatch(
      ConnectedRouter.push(RouteParser.create(location).linkToCheckoutPage()),
    ),
  purchaseAction: () => handlePurchaseClick(dispatch),
  toggleSummaryAction: () => dispatch(toggleSummary()),
  summaryHeightAction: (summaryComponentHeight) => {
    dispatch(summaryHeight(summaryComponentHeight));
  },
  toggleSummaryMobileAction: (direction) => {
    dispatch(toggleSummaryMobile(direction));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  // checkoutAction requires state to know where to link to
  checkoutAction: () =>
    dispatchProps.checkoutAction(stateProps.currentLocation),
});

const SummaryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Summary);

export default SummaryContainer;
